import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { FartherAccountId, PhysicalAccountId, TransferId, } from "../../Types";
import ValidationError from "../../ZodError";
const LiquidationStatus = z.enum([
    "CANCELED",
    "COMPLETE",
    "ERROR",
    "PENDING_CANCELLATION",
    "PENDING_INITIATION",
    "PENDING_PROCESSING",
    "PENDING_TRANSFER",
]);
export const LiquidationId = z.custom((val) => typeof val === "string");
const LiquidationApexStatus = z.enum([
    "REQUESTED",
    "CASH_AVAILABLE",
    "TRANSFER_PENDING",
    "COMPLETE",
    "CANCELED",
    "SENTINEL_ERROR",
]);
const LiquidationCustodianDetails = z.object({
    status: LiquidationApexStatus,
    apexLiquidationId: z.string(),
});
const Liquidation = z.object({
    createTime: z.string(),
    transferId: TransferId,
    modifyTime: z.string(),
    status: LiquidationStatus,
    liquidationId: LiquidationId,
    physicalAccountId: PhysicalAccountId,
    virtualAccountId: FartherAccountId,
    amount: z.number().nullable(),
    isFullLiquidation: z.boolean(),
    custodianDetails: LiquidationCustodianDetails.nullable(),
});
const Response = z.object({ liquidations: Liquidation.array() });
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/transfer/v1/liquidations"
    : "https://middleware.uat.farther.com/transfer/v1/liquidations";
export default async function getLiquidations(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getLiquidations returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getLiquidations.js.map